function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_27",
  "data-name": "Ellipse 27",
  cx: 10.236,
  cy: 10.236,
  rx: 10.236,
  ry: 10.236,
  transform: "translate(0 0)",
  fill: "#a39383"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_101",
  "data-name": "Rectangle 101",
  width: 14.461,
  height: 14.461,
  transform: "translate(3.005 2.978)",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M71.65,66.952a17.353,17.353,0,0,1,2.269.063,2.926,2.926,0,0,1,1.072.189,2.212,2.212,0,0,1,1.072,1.071,2.928,2.928,0,0,1,.189,1.072c0,.567.063.756.063,2.269a17.364,17.364,0,0,1-.063,2.269,2.925,2.925,0,0,1-.189,1.071,2.21,2.21,0,0,1-1.072,1.072,2.926,2.926,0,0,1-1.072.189c-.567,0-.756.063-2.269.063a17.364,17.364,0,0,1-2.269-.063,2.926,2.926,0,0,1-1.072-.189,2.212,2.212,0,0,1-1.071-1.072,2.912,2.912,0,0,1-.189-1.071c0-.568-.063-.757-.063-2.269a17.363,17.363,0,0,1,.063-2.269,2.912,2.912,0,0,1,.189-1.072,2.272,2.272,0,0,1,.437-.63,1.064,1.064,0,0,1,.63-.441,2.926,2.926,0,0,1,1.072-.189,17.363,17.363,0,0,1,2.273-.063m0-1.008a18.616,18.616,0,0,0-2.33.067,3.874,3.874,0,0,0-1.383.252A2.646,2.646,0,0,0,66.292,67.9a2.874,2.874,0,0,0-.248,1.389,18.616,18.616,0,0,0-.063,2.33,18.608,18.608,0,0,0,.063,2.33,3.887,3.887,0,0,0,.252,1.387,2.646,2.646,0,0,0,1.639,1.639,3.891,3.891,0,0,0,1.383.253,18.746,18.746,0,0,0,2.33.063,18.607,18.607,0,0,0,2.33-.063,3.889,3.889,0,0,0,1.387-.253A2.644,2.644,0,0,0,77,75.333a3.888,3.888,0,0,0,.253-1.383c0-.63.063-.819.063-2.33a18.616,18.616,0,0,0-.063-2.33A3.894,3.894,0,0,0,77,67.907a2.644,2.644,0,0,0-1.639-1.638,3.868,3.868,0,0,0-1.384-.258,18.607,18.607,0,0,0-2.33-.063m0,2.773a2.853,2.853,0,0,0-2.9,2.805v.095a2.9,2.9,0,1,0,2.9-2.9h0m0,4.791a1.857,1.857,0,0,1-1.893-1.82v-.071a1.857,1.857,0,0,1,1.82-1.893h.073a1.857,1.857,0,0,1,1.893,1.82v.069a1.857,1.857,0,0,1-1.82,1.893H71.65M74.676,67.9a.694.694,0,1,0,.693.694h0a.7.7,0,0,0-.693-.694",
  transform: "translate(-61.414 -61.38)",
  fill: "#fff",
  fillRule: "evenodd"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TES_005_Instagram",
    "data-name": "TES 005_Instagram",
    width: 20.473,
    height: 20.473,
    viewBox: "0 0 20.473 20.473",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Instagram.02f89cb8.svg";
export { ForwardRef as ReactComponent };